<template>

  <form >

    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Creating An OutLet</h4>
        <p class="category">Hey {{ name }}, Tell us about your outlet</p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Outlet Name</label>
              <md-input v-model="user.outletName" type="textarea"> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Category</label>
              <md-select v-model="user.category" name="category" >
                <md-option v-for="cate in categories" :value="cate" >{{cate}}</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Outlet Description - tell the buyers what you offer and describe your service</label>
              <md-textarea v-model="user.description"> </md-textarea>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>City</label>
              <md-input v-model="user.city" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Canton</label>
              <md-input v-model="user.canton" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Building</label>
              <md-input v-model="user.building" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Street</label>
              <md-input v-model="user.street" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Website</label>
              <md-input v-model="user.website" type="link"></md-input>
            </md-field>
          </div>

        </div>

        <div class="md-layout">

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Address Line</label>
              <md-input v-model="user.address" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Zip Code</label>
              <md-input v-model="user.zip" type="number"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Email</label>
              <md-input v-model="user.email" type="email"> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Primary Contact</label>
              <md-input v-model="user.primaryContact" type="phone">0</md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <p>Days of operation</p>
            <md-checkbox v-model="days" value=1>Mon</md-checkbox>
            <md-checkbox v-model="days" value=2>Tue</md-checkbox>
            <md-checkbox v-model="days" value=3>Wed</md-checkbox>
            <md-checkbox v-model="days" value=4>Thur</md-checkbox>
            <md-checkbox v-model="days" value=5>Fri</md-checkbox>
            <md-checkbox v-model="days" value=6>Sat</md-checkbox>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>From</label>
              <md-input v-model="user.startTime" type="time"> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>To</label>
              <md-input v-model="user.endTime" type="time"> </md-input>
            </md-field>
          </div>

          <div
            class="md-layout-item md-size-100 text-center"
            :data-background-color="dataBackgroundColor">
            <md-button class="md-raised" @click="validateAndNext">Next</md-button>
          </div>

        </div>
      </md-card-content>
    </md-card>

    <md-snackbar  :md-duration="Infinity" :md-active.sync="showSnackbar" md-persistent>
      <span>{{message}}</span>
      <md-button @click="showSnackbar = false">OK</md-button>
    </md-snackbar>

  </form>

</template>
<script>
import firebase from "../../Firebase";
export default {
  name: "edit-profile-form",
  props: {
    user : {
        type: Object,
    },name: {
        type: String
    },
    dataBackgroundColor: {
      type: String,
      default: "purple"
    }
  },created(){
      firebase.firestore().collection("categories").get().then( docSnap => {
          this.categories = [];
          docSnap.forEach(doc => this.categories.push(doc.data()['name']))
      })
    }, data() {
    return {
        showSnackbar : false,
        message : "",
        category : null,
        categories : [],
        days : []
    };
  },
  methods : {
      validateAndNext(){
          this.user.days = this.days;
          if(!this.user.outletName || !this.user.zip || !this.user.category || !this.user.city || !this.user.address
              || !this.user.description || !this.user.email || !this.user.primaryContact || !this.user.building ||
              !this.user.street || !this.user.website || !this.user.startTime || !this.user.endTime || this.days.length<1)
              alert('Fill All Entries');
          else {
              this.user.setup = 1;
              firebase.firestore().collection("sellers").doc(this.user.uid)
                  .update( this.user )
                  .catch(error => {
                      this.message = error.message;
                      this.showSnackbar = true;
                      console.log(error)
                  })
          }
      }
  }
};
</script>
<style></style>
